exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-dialog .el-dialog__body[data-v-e7434124]{padding-top:5px;padding-bottom:10px}.form-dialog .el-dialog__body .el-form-item[data-v-e7434124]{margin-bottom:12px}\n", ""]);

// exports
